import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { loginUser } from "../../../redux/slices/userSlice";

import "../../../assets/css/bootstrap.css";
import IconButton from "../../../components/IconButton/IconButton";
import { EyeIcon, EyeSlashIcon } from "../../../components/Icon/icons";
import AuthenticationLayout from "../../../components/UI/AuthenticationLayout/AuthenticationLayout";
import ButtonSpinner from "../../../components/UI/ButtonSpinner/ButtonSpinner";
import FormAlert from "../../../components/UI/FormAlert/FormAlert";

function LoginScreen() {
  const [isPasswordShown, setIsPasswordShown] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const dispatch = useDispatch();
  const userSlice = useSelector((state) => state.userSlice);

  const onChangeIsPasswordShown = () => {
    setIsPasswordShown(!isPasswordShown);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(loginUser({ email, password }));
  };

  return (
    <>
      <Helmet>
        <title>Login</title>
        <link rel="stylesheet" href="/bootstrap.alt.css" />
      </Helmet>

      <AuthenticationLayout>
        <div className="authentication-form">
          <h4>Entre na sua conta:</h4>

          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="email" className="mb-3">
              <Form.Floating>
                <Form.Label>E-mail</Form.Label>
                <InputGroup>
                  <Form.Control required type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                </InputGroup>
              </Form.Floating>
            </Form.Group>

            <Form.Group controlId="password" className="mb-3">
              <Form.Floating>
                <Form.Label>Senha</Form.Label>
                <InputGroup>
                  <Form.Control
                    required
                    type={isPasswordShown ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />

                  <IconButton className="form-control-icon" style={{ padding: 0 }} onClick={onChangeIsPasswordShown}>
                    {isPasswordShown ? <EyeIcon /> : <EyeSlashIcon />}
                  </IconButton>
                </InputGroup>
              </Form.Floating>
            </Form.Group>

            <InputGroup className="mb-3 justify-content-center">
              <Form.Check className="pe-1" checked={true} disabled={true} />
              <Form.FloatingLabel>Lembre-me</Form.FloatingLabel>
            </InputGroup>

            <ButtonSpinner type="submit" isLoading={userSlice.loading}>
              Login
            </ButtonSpinner>
            <Link className="hiperlink" to="/password-reset">
              Recuperar Senha
            </Link>
          </Form>
        </div>

        {userSlice.error && <FormAlert alertTextList={userSlice.error} />}
      </AuthenticationLayout>
    </>
  );
}

export default LoginScreen;
